module.exports = __webpack_public_path__ + "static/media/_capa.5feb9ee9.jpg";